import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Styled native checkbox for forms (design-system aligned).
 */
const Checkbox = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        'h-4 w-4 shrink-0 rounded border-slate-300 text-blue-600',
        'focus:ring-2 focus:ring-blue-500 focus:ring-offset-0',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
});

Checkbox.displayName = 'Checkbox';

export { Checkbox };
export default Checkbox;
